import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { QuillModule } from "ngx-quill";
import "quill/dist/quill.snow.css";
@Component({
  selector: "app-text-editor",
  standalone: true,
  imports: [QuillModule, FormsModule], // Import Quill and FormsModule for ngModel
  templateUrl: "./text-editor.component.html",
  styleUrl: "./text-editor.component.scss",
})
export class TextEditorComponent {
  text: string = "";
  formattedText: string = "";
  @Input() label: string = "Prerequisites";
  @Input() placeholder: any = "Enter Prerequisites...";
  @Output() textChange = new EventEmitter<string>();
  editorConfig = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline"],
      ["code-block"],
      // [{ 'script': 'sub' }, { 'script': 'super' }],
      // [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ align: [] }],
      [
        { color: [] },
        //  { 'background': [] }
      ],
      [{ list: "ordered" }, { list: "bullet" }],
      // ['clean']
    ],
  };

  onContentChanged(event: any) {
    let cleanedHtml = this.decodeHtmlEntities(this.text); 
    cleanedHtml = cleanedHtml.replace(/<\/?p[^>]*>/g, '');
    
    if (cleanedHtml.includes("<ol>") || cleanedHtml.includes("<ul>")) {
      this.formattedText = this.convertTextToNumberedList(cleanedHtml);
    } else {
      this.formattedText = cleanedHtml.replace(/<[^>]+>/g, "").trim();
    }
    this.textChange.emit(this.formattedText);
  }

  decodeHtmlEntities(input: string): string {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = input;
    return textarea.value;
  }
  

  convertTextToNumberedList(html: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    let result = "";

    // Handle ordered lists (<ol>)
    const orderedItems = doc.querySelectorAll("ol > li");
    orderedItems.forEach((li, index) => {
      result += `${index + 1}. ${li.textContent?.trim()}\n`;
    });

    // Handle unordered lists (<ul>)
    const unorderedItems = doc.querySelectorAll("ul > li");
    unorderedItems.forEach((li) => {
      result += `• ${li.textContent?.trim()}\n`;
    });

    return result;
  }
}
